/** Explosions, births and Digby's death (docs/spec/02 §6). */

import { BIRTH_STAGES, E, EXPLODE_STAGES, EXPLOSION_PROOF, isButterfly } from '../elements';
import { at, put, store } from '../grid';
import type { CaveState } from '../types';

export function killDigby(s: CaveState, x: number, y: number): void {
  if (!s.digby.alive) return;
  s.digby.alive = false;
  s.digby.x = x;
  s.digby.y = y;
  if (s.status === 'playing') s.status = 'dead';
  s.events.push({ type: 'died', x, y });
}

/**
 * The 3 x 3 around (cx, cy) becomes explosion stage 1, or diamond birth stage 1. Explosions do
 * not chain: whatever was in a cell is simply replaced (02 §6).
 */
export function explode(s: CaveState, cx: number, cy: number, kind: 'space' | 'diamonds'): void {
  s.events.push({ type: 'explode', x: cx, y: cy, kind });
  const first = kind === 'space' ? E.EXPLODE : E.DIAMOND_BIRTH;
  for (let y = cy - 1; y <= cy + 1; y++) {
    for (let x = cx - 1; x <= cx + 1; x++) {
      if (x < 0 || y < 0 || x >= s.w || y >= s.h) continue;
      const el = at(s, x, y);
      if (EXPLOSION_PROOF[el] === 1) continue;
      if (el === E.DIGBY) killDigby(s, x, y);
      store(s, x, y, first);
    }
  }
}

/** A falling object has landed on something that explodes when hit (02 §3). */
export function explodeHit(s: CaveState, x: number, y: number, hit: number): void {
  explode(s, x, y, isButterfly(hit) ? 'diamonds' : 'space');
}

/** Advance an explosion, diamond birth or Digby birth cell one stage. */
export function advanceStage(s: CaveState, x: number, y: number, el: number): void {
  if (el >= E.EXPLODE && el < E.EXPLODE + EXPLODE_STAGES) {
    put(s, x, y, el === E.EXPLODE + EXPLODE_STAGES - 1 ? E.SPACE : el + 1);
  } else if (el >= E.DIAMOND_BIRTH && el < E.DIAMOND_BIRTH + EXPLODE_STAGES) {
    put(s, x, y, el === E.DIAMOND_BIRTH + EXPLODE_STAGES - 1 ? E.DIAMOND : el + 1);
  } else if (el >= E.BIRTH && el < E.BIRTH + BIRTH_STAGES) {
    if (el === E.BIRTH + BIRTH_STAGES - 1) {
      put(s, x, y, E.DIGBY);
      s.digby.born = true;
      s.digby.x = x;
      s.digby.y = y;
      s.bornMs = s.ms;
      s.events.push({ type: 'born', x, y });
    } else put(s, x, y, el + 1);
  }
}

/** The inbox flashes until the hatch scan, then Digby's birth begins. */
export function inbox(s: CaveState, x: number, y: number): void {
  if (s.scan >= s.hatchScan) put(s, x, y, E.BIRTH);
}
